import { useContext } from 'react';
import { WizardContext } from './WizardContext';
export var useWizard = function () {
    var context = useContext(WizardContext);
    if (!context) {
        throw new Error('useWizard must be used within a WizardProvider');
    }
    return context;
};
